import {
  SET_CONNECT_SESSION,
  SET_CHAT_CONNECTED,
  SET_CHAT_INITIAL_CONTACT_ID,
  SET_CHAT_CURRENT_CONTACT_ID,
  SET_RETRY_COUNTER,
} from "./types";
import {
  retryAction,
  SendMessageUnexpectedError,
} from "../../common/CustomError";
import { config } from "../../components/Chat/Chat";
import {
  uploadChatLogs,
  chatTransfer,
  scrubMessage,
} from "../../api/ChatAPI.js";
import {
  renderChat,
  setChatWidgetOpened,
  setChatHeaderTitle,
} from "./chatActions";
import {
  setIsChatEnabled,
  addMessage,
  replaceMessage,
  undoAddMessage,
  setOnTyping,
  setMessageToSend,
  setDeliveredMessageId,
  setReadMessageId,
} from "./messagePaneActions";
import moment from "moment";
import store from "../../redux";
import { Mutex, withTimeout } from "async-mutex";
import { logger } from "../../common/Logger";
import {
  isJson,
  convertLink,
  uuidv4,
  getMessage,
} from "../../common/ChatUtil.js";
import { AmazonConnectParticipantAPI } from "../../api/AmazonConnectParticipantAPI";
import { setError } from "./errorActions";
import {
  setIsAgentConnected,
  clearMessageList,
  setSoundOff,
} from "./messagePaneActions.js";
import messagePaneReducer from "../reducers/messagePaneReducer";
import { debuglogger } from "../../common/debugLogger";

let clientLock = withTimeout(new Mutex(), 5000);

let amazonConnectParticipantAPI;
let scrubbedMessage = {};

export const startConnectParticipant =
  (_config, retryChat, endChatComplete) => (dispatch) => {
    try {
      debuglogger("startConnectParticipant");
      amazonConnectParticipantAPI = new AmazonConnectParticipantAPI({
        eventHandler: {
          onWsConnectionNetworkError: (error) =>
            dispatch(onWsConnectionNetworkErrorEventHandler(error)),
          onConnectionEstablished: ({ event, getTranscript }) =>
            dispatch(
              onWsConnectionEstablishedEventHandler({
                event,
                getTranscript,
                retryAction: retryChat,
              })
            ),
          onConnectionBroken: (event) =>
            dispatch(onWsConnectionBrokenEventHandler(event)),
          onConnectionLost: (event) =>
            dispatch(onWsConnectionLostEventHandler(event)),
          onEnded: (event) =>
            dispatch(
              onWsSessionEndedEventHandler({
                event,
                endChatComplete: (fromRetry, fromWSSessionEnd) =>
                  endChatComplete(fromRetry, fromWSSessionEnd),
              })
            ),
          onMessage: (message) => dispatch(onWsMessageEventHandler(message)),
          onTyping: (typingEvent) =>
            dispatch(onWsTypingEventHandler(typingEvent)),
          onDeliveredReceipt: (event) => dispatch(onWsDeliveredReceipt(event)),
          onReadReceipt: (event) => dispatch(onWsReadReceipt(event)),
        },
      });

      amazonConnectParticipantAPI
        .connect(_config)
        .then((session) => {
          config.sessionID = session.sessionID;
          dispatch({
            type: SET_CONNECT_SESSION,
            payload: session,
          });
          sessionStorage.setItem(
            "initialContactId",
            _config.chatDetails.ContactId
          ); // use by DYNATRACE_RUM_AGENT
          sessionStorage.setItem("connectSessionId", _config.sessionID); // use by DYNATRACE_RUM_AGENT
          notifyParent("Connected-true");
          return session;
        })
        .catch((error) => {
          console.error(
            "caught error from amazonConnectParticipantAPI.connect",
            error.toString()
          );
          if (
            error
              .toString()
              ?.includes("Expired or Invalid Connect ParticipantToken") &&
            store.getState().amazonConnectReducer.retryCounter < 3
          ) {
            console.error(
              "auto initializing after connect 403, counter: ",
              store.getState().amazonConnectReducer.retryCounter
            );
            try {
              dispatch({
                type: SET_RETRY_COUNTER,
                payload: store.getState().amazonConnectReducer.retryCounter + 1,
              });
            } catch (error) {
              console.error("setRetryCounter Error", error);
            }
            retryChat();
          } else {
            try {
              dispatch({
                type: SET_RETRY_COUNTER,
                payload: 0,
              });
            } catch (error) {
              console.error("setRetryCounter Error", error);
            }
            dispatch(
              setError({
                error: error,
                retryAction: retryChat,
                errorCode: "E004",
              })
            );
          }
          debuglogger("startConnectParticipant Error" + error);
          notifyParent("Connected-false");
        });
    } catch (error) {
      console.error("startConnectParticipant Error", error);
    }
  };

export const endConnectParticipant =
  (fromRetry, fromWSSessionEnd) => async (dispatch) => {
    try {
      const status = await amazonConnectParticipantAPI.disconnect();
      if (!fromRetry) {
        dispatch(setChatWidgetOpened(false));
        notifyParent({ message: "hideChat", value: "hide" });
        notifyParent("ChatEnded-true");
      }
      dispatch(clearMessageList());

      dispatch(setChatConnected(false));
      dispatch(setIsAgentConnected(false));
      dispatch(
        setIsChatEnabled({
          isNetworkError: false,
          restartFlag: false,
          isConnectParticipantTokenInvalid: false,
        })
      );

      dispatch(setMessageToSend(""));
      dispatch(setSoundOff(false));
      dispatch(setChatHeaderTitle(""));

      // notify the embedded chat page that the chat widget is now closing.
      // if (!fromRetry) {
      //   dispatch(setChatWidgetOpened(false));
      //   notifyParent({ message: "hideChat", value: "hide" });
      //   notifyParent("ChatEnded-true");
      // }
      if (fromWSSessionEnd) {
        notifyParent("Session-ended");
      }
      // render empty widget
      dispatch(renderChat({}));

      dispatch(setChatConnected(false));
      //sessionStorage.removeItem("connectSessionId"); // use by DYNATRACE_RUM_AGENT
      //sessionStorage.removeItem("initialContactId"); // use by DYNATRACE_RUM_AGENT
      return status;
    } catch (error) {
      console.error("setChatConnected Error", error);
    }
  };

export const setChatConnected = (chatConnected) => (dispatch) => {
  try {
    if (store.getState().amazonConnectReducer.chatConnected !== chatConnected) {
      dispatch({ type: SET_CHAT_CONNECTED, payload: chatConnected });
    }
  } catch (error) {
    console.error("setChatConnected Error", error);
  }
};

export const onWsConnectionNetworkErrorEventHandler = (error) => (dispatch) => {
  try {
    if (store.getState().messagePaneReducer.isChatEnabled.isNetworkError) {
      return false;
    } else {
      if (
        error.includes("Network Failure") ||
        error.includes("Network offline")
      ) {
        dispatch(
          setIsChatEnabled({
            isNetworkError: true,
          })
        );
        return true;
      } else if (
        error.includes("AccessDeniedException") ||
        error.includes("Access denied") ||
        error.includes("ConnectAccessDeniedError")
      ) {
        dispatch(
          setIsChatEnabled({
            isConnectParticipantTokenInvalid: true,
          })
        );
        return false;
      }
      return false;
    }
  } catch (err) {
    console.error("onWsConnectionNetworkErrorEventHandler Error", err);
  }
};

export const onWsSessionEndedEventHandler =
  ({ event, endChatComplete }) =>
  (dispatch) => {
    try {
      debuglogger("***GOING INSIDE WS SESSION ENDED");
      logger.info("triggered the onWsSessionEndedEventHandler ", {
        event,
        initialContactId:
          store.getState().amazonConnectReducer.initialContactId,
      });
      //isChatConnected is set to false when user hit the close x, it calls the endChatComplete where it set it to false
      // basically, we do not want the endChatComplete to be called from here when the user ended the chat.
      if (
        store.getState().amazonConnectReducer.chatConnected &&
        store.getState().amazonConnectReducer.initialContactId ===
          event?.chatDetails.initialContactId // making sure that one we are ending the chat is for initialContactId
      ) {
        uploadChatLogs(config, {
          eventStr: "onEnded-AGENT",
          event,
        });
        endChatComplete(false, true);
      }
    } catch (err) {
      console.error("onWsSessionEndedEventHandler Error", err);
    }
  };

export const onWsConnectionLostEventHandler = (event) => (dispatch) => {
  logger.info("triggered the onConnectionLost ", event);
  uploadChatLogs(config, {
    eventStr: "onConnectionLost",
    event,
  });
};

export const onWsConnectionBrokenEventHandler = (event) => (dispatch) => {
  logger.info("triggered the onWsConnectionBrokenEventHandler ", event);
  uploadChatLogs(config, {
    eventStr: "onConnectionBroken",
    event,
  });
};

export const onWsTypingEventHandler = (typingEvent) => (dispatch) => {
  if (typingEvent.data.ParticipantRole === "AGENT") {
    dispatch(setOnTyping(true));
  }
};

export const onWsMessageEventHandler = (message) => async (dispatch) => {
  debuglogger("onWsMessageEventHandler" + message);
  var messageObjList = dispatch(
    onMessageFunc(message, message.data.AbsoluteTime, true)
  );
  if (messageObjList.length > 0) {
    let release = await clientLock.acquire();
    try {
      ///do dispatch here
      dispatch(addMessage(messageObjList, true));
    } catch (e) {
      console.error("Exception during addMessage processing", e);
    } finally {
      release();
    }
  }
};

export const onWsConnectionEstablishedEventHandler =
  ({ event, getTranscript, retryAction }) =>
  async (dispatch) => {
    uploadChatLogs(config, {
      eventStr: "onConnectionEstablished",
      event: JSON.stringify(event),
    });

    if (
      store.getState().amazonConnectReducer.initialContactId !==
      event.chatDetails.initialContactId
    ) {
      dispatch({
        type: SET_CHAT_INITIAL_CONTACT_ID,
        payload: event.chatDetails.initialContactId,
      });
    }

    if (event.connectCalled && event.connectSuccess) {
      logger.info("Triggered onConnectionEstablished to skiped.", event);
      return;
    } else {
      logger.info("Triggered onConnectionEstablished to process.", event);
    }

    if (store.getState().messagePaneReducer.isChatEnabled.isNetworkError) {
      debuglogger("onConnectionEstablished connection is success!!! ");
      dispatch(
        setIsChatEnabled({
          isNetworkError: true,
        })
      );
    } else {
      dispatch(
        renderChat({
          from: "12",
          loaderPane: { loaderMessage: "chatLoader" },
        })
      );
    }
    dispatch(setChatConnected(true));
    notifyParent("ConnectionEstablished-true");

    //Logic explanation in comments
    //1st time chatter: previousContactIdValue = "INITIAL_CHAT" (dont go to below if)..... Persist this 1st timer: previousContactIdValue = "INITIAL_CHAT" (go to if)
    //End/new Chat: previousContactIdValue = "hkjdhfkjhf" (dont go to if) ..... Persist this previousContactIdValue = "hkjdhfkjhf" (go to if)
    //calling native transcript api

    try {
      const response = await getTranscript();
      const { Transcript } = response;

      debuglogger(
        "Transcript size: " +
          "\nconnectTranscriptSize: " +
          Transcript.length +
          "\nmessageListToDisplaySize: " +
          store.getState().messagePaneReducer.messageList.length
      );

      //Below if keeps the loader for 'Loading Chat' on when transcript comes back empty
      if (Transcript.length !== 0) {
        // isinputBarEnabled = true;
        let addMessageObjList = [];

        for (let message of Transcript) {
          var messageObj = dispatch(
            onMessageFunc(
              {
                data: message,
                chatDetails: { contactId: response.InitialContactId },
              },
              message.AbsoluteTime,
              store.getState().messagePaneReducer.isChatEnabled.isNetworkError
            )
          );
          addMessageObjList.push(...messageObj);
        }
        if (addMessageObjList && addMessageObjList.length > 0) {
          dispatch(
            addMessage(addMessageObjList, false, Transcript.length === 0)
          );
        }
      }
    } catch (error) {
      dispatch(
        setError({ error: error, retryAction: retryAction, errorCode: "E005" })
      );
    }
  };

export const onWsDeliveredReceipt = (event) => (dispatch) => {
  dispatch(setDeliveredMessageId("a" + event.data.MessageMetadata.MessageId));
  dispatch(
    renderChat({
      from: "M005",
      messagePane: { messagePaneReady: true },
    })
  );
};

export const onWsReadReceipt = (event) => (dispatch) => {
  //when a Read WS (valueToUpdate variable holds that incoming WS status) comes in, clear out isDeliveredExists because now that message needs to be updated to read status
  dispatch(setDeliveredMessageId(""));
  dispatch(setReadMessageId("a" + event.data.MessageMetadata.MessageId));
  dispatch(
    renderChat({
      from: "M006",
      messagePane: { messagePaneReady: true },
    })
  );
};

export const sendChatMessageToConnect =
  (messageContent, scrubbingRequired = false) =>
  async (dispatch) => {
    const userMessageObj = {
      messageText: messageContent,
      userType: "CUSTOMER",
      messageUserName: config.userName,
      messageTime: moment(),
      id: "aTempMessage" + uuidv4(),
    };
    let erroredFlag = false;
    if (!scrubbingRequired) {
      dispatch(addMessage([userMessageObj]), false);
    }
    if (scrubbingRequired) {
      try {
        scrubbedMessage = await scrubMessage(config, messageContent);
        const replacedMessage = getMessage(messageContent, scrubbedMessage);

        if (messageContent !== replacedMessage) {
          dispatch(replaceMessage(userMessageObj.id, replacedMessage));
        }
      } catch (error) {
        console.error(" error on scrubbing", error);
        // handle placing message back into input area here
        document.getElementById("chatTextBoxId").value = messageContent;
        erroredFlag = true;
        dispatch(
          setError({
            error: error,
            retryAction: retryAction,
            errorCode: "E003",
          })
        );
      }
      if (
        JSON.stringify(scrubbedMessage) !== "{}" &&
        scrubbedMessage?.body?.scrubMessage !== ""
      ) {
        dispatch(setMessageToSend(scrubbedMessage.body.scrubMessage));
      }
    }

    if (!erroredFlag) {
      try {
        if (scrubbingRequired && scrubbedMessage?.body.scrubMessage !== "") {
          await amazonConnectParticipantAPI.sendMessage(
            scrubbedMessage?.body.scrubMessage
          );
          scrubbedMessage = {};
        } else {
          await amazonConnectParticipantAPI.sendMessage(
            userMessageObj.messageText
          );
        }
      } catch (error) {
        dispatch(undoAddMessage(userMessageObj.id));
        dispatch(
          setError({
            error: new SendMessageUnexpectedError(error.message),
            retryAction: () => {
              dispatch(
                renderChat({
                  from: "34a",
                  messagePane: { messagePaneReady: true },
                })
              );
            },
            errorCode: "E010",
          })
        );
        //}
      }
    }
    notifyParent("chatActive");
    // notify parent here
    notifyParent("chatActive");
    // notify parent here
  };

export const sendOnTypingAlert = (value) => async (dispatch) => {
  try {
    await amazonConnectParticipantAPI.sendTypingEvent(value);
  } catch (error) {
    if (dispatch(onWsConnectionNetworkErrorEventHandler(error.toString()))) {
      return;
    } else {
      logger.error("sendOnTypingAlert error : ", error);
    }
  }
};
////////////////////////////////////////////////////////////////
// helper functions
///////////////////////////////////////////////////////////////
export const onMessageFunc =
  (message, timestamp, fromWebSocket = false) =>
  (dispatch) => {
    store.getState().messagePaneReducer.isChatEnabled.isNetworkError &&
      dispatch(
        setIsChatEnabled({
          isNetworkError: false,
        })
      );

    let addMessageObjList = [];

    const messageObj = {
      contactId: message?.data?.ContactId, //
      id: "a" + message?.data?.Id,
      userType: message?.data?.ParticipantRole, //
      messageUserName: message?.data?.DisplayName, //
      messageText: message?.data?.Content, //
      messageTime: (timestamp && moment(timestamp)) || moment(), //
      contentType: message?.data?.ContentType,
    };

    //makes links clickable when sent by Rep
    switch (message.data.Type) {
      case "ATTACHMENT":
        // const sampleAttachmentResponse = {
        //   AbsoluteTime: "2024-05-01T14:19:02.973Z",
        //   Attachments: [
        //     {
        //       ContentType: "text/plain",
        //       AttachmentId: "58f53376-79ad-4756-98a6-11d29892c1b0",
        //       AttachmentName: "foo.txt",
        //       Status: "APPROVED",
        //     },
        //   ],
        //   Id: "9c47ab24-6b21-4dae-a57e-9718b8a5b755",
        //   Type: "ATTACHMENT",
        //   ParticipantId: "d6325910-3a07-42f2-8a71-5d9941408bcb",
        //   DisplayName: "jeff linsangan-emg6",
        //   ParticipantRole: "CUSTOMER",
        //   InitialContactId: "6a8ab028-d0d5-4ced-b751-6373a7b31913",
        //   ContactId: "6a8ab028-d0d5-4ced-b751-6373a7b31913",
        // };
        const attachments = message?.data?.Attachments;
        messageObj.messageText = `<a href="${attachments[0].AttachmentName}">${attachments[0].AttachmentName}</a>`;
        // "file:" +
        //   attachments[0].AttachmentName +
        //   ", Status:" +
        //   attachments[0].Status +
        //   ", AttachmentId:" +
        //   attachments[0].AttachmentId;
        messageObj.contentType = attachments[0].ContentType;
        addMessageObjList = [{ ...messageObj }];
        //<a href="https://www.w3schools.com">attachments[0].AttachmentName</a>
        //sample from HRD
        // <a href="https://sf-connectcontactcenter-test-west.my.connect.aws/ccp-v2/foo.txt >foo.txt</a>
        //s3://ctm-attachment-poc/
        //connect/sf-connectcontactcenter-test-west/Attachments/chat/2024/05/01/89ea54a4-1596-42dd-9836-50ed9f8e1bc1_4573db8f-bc71-41a5-8613-8e075a64bdc1_20240501T15:26_UTC.txt
        break;

      case "EVENT":
        if (
          fromWebSocket &&
          messageObj.contentType !==
            "application/vnd.amazonaws.connect.event.participant.left" &&
          messageObj.contactId &&
          messageObj.contactId !==
            store.getState().messagePaneReducer.currentContactId
        ) {
          dispatch(handleTransferEvent(messageObj.contactId)); //removed sso
        }

        if (
          messageObj.userType === "AGENT" &&
          messageObj.contentType ===
            "application/vnd.amazonaws.connect.event.participant.joined"
        ) {
          addMessageObjList = [
            {
              ...messageObj,
              messageText: `<b> ${messageObj.messageUserName} joined the chat.</b> <br/><br/>To effectively utilize our available resources, if you are holding on the phones, you may disconnect that call once connected with a Chat representative. Chats are timed live sessions. Once connected, please monitor the conversation for its entire duration to ensure a timely resolution.`,
              userType: "EVENT",
            },
          ];
        }
        break;

      case "MESSAGE":
        //authenticated customer facing
        if (config.customerFacing === "true" && fromWebSocket) {
          const eventLog = {
            eventStr: "onMessageFunc",
            messageID: messageObj.id,
            ParticipantRole: messageObj.userType,
            ContactId: messageObj.contactId,
            messageSize: messageObj.messageText
              ? messageObj.messageText.length
              : 0,
            message: messageObj.messageText
              ? messageObj.messageText.substr(0, 3)
              : "Undefined",
          };
          uploadChatLogs(config, eventLog);
        }

        switch (messageObj.userType) {
          case "CUSTOMER":
            dispatch(setMessageToSend("")); // reset the MessageToSend after message is recieved from connect
            // dispatch(
            //   renderChat({
            //     from: "M005",
            //     messagePane: { messagePaneReady: true },
            //   })
            // );
            //addMessageObjList = [{ ...messageObj }];
            //Start of logic for Transcript
            const userMessage = store
              .getState()
              .messagePaneReducer.messageList.find(({ id }) =>
                id.includes(message.data.Id)
              );
            if (!userMessage) {
              //   Receipts[
              //     {
              //         "DeliveredTimestamp": "2024-04-30T14:22:14.976Z",
              //         "ReadTimestamp": "2024-04-30T14:22:14.976Z",
              //         "RecipientParticipantId": "c1425d36-d3bd-42c5-8e4d-c8094c5f69d0"
              //     }
              // ]

              //All customer messages have a MessageMetadata but the BOT replied customer messages have Receipts as [] hence we need to check below

              if (message.data.MessageMetadata?.Receipts.length > 0) {
                //ReadTimestamp from transcript only shows up if that message has been Read else it is null, so if that exists we do not need to check DeliveredTimestamp and set it to 'None'
                if (
                  message.data.MessageMetadata?.Receipts[0]?.ReadTimestamp !==
                  null
                ) {
                  dispatch(setDeliveredMessageId(""));
                  dispatch(
                    setReadMessageId(
                      "a" + message.data.MessageMetadata.MessageId
                    )
                  );
                }
                //else means DeliveredTimestamp is only available, no ReadTimestamp available, hence we update isDeliveredExists to that message's id
                else if (
                  message.data.MessageMetadata?.Receipts[0]
                    ?.DeliveredTimestamp !== null
                ) {
                  dispatch(
                    setDeliveredMessageId(
                      "a" + message.data.MessageMetadata.MessageId
                    )
                  );
                }
              }
              //Adding the readDeliveryStatus variable to the messageObj with "None" status.
              //It will get set to appropriate value in onWsConnectionEstablishedEventHandler based on the above isDeliveredExists and isReadExists values
              addMessageObjList = [
                // { ...messageObj, readDeliveryStatus: "None" },
                { ...messageObj },
              ];
              //End of logic for Transcript
            }
            break;

          case "AGENT":
            addMessageObjList = [
              {
                ...messageObj,
                messageText: convertLink(messageObj.messageText),
              },
            ];
            break;

          case "SYSTEM":
            logger.debug(" Bot/System message type", messageObj.contentType);
            const isContentJson =
              messageObj.messageText && isJson(messageObj.messageText);
            messageObj.messageText = isContentJson
              ? JSON.parse(messageObj.messageText)
              : messageObj.messageText;

            switch (true) {
              case !isContentJson: //"plain text"
                addMessageObjList = [{ ...messageObj }];
                break;

              case messageObj.messageText?.templateType === "ListPicker":
                messageObj.messageText.isInteractiveMessageClicked = false;
                addMessageObjList = [{ ...messageObj }];
                break;

              default: //quick reply
                messageObj.messageText.forEach((botMessage, index, array) => {
                  const addMessageObj = {
                    ...messageObj,
                    id: messageObj.id + (array.length === 1 ? "" : "-" + index),
                    messageText: botMessage,
                  };
                  // split quick replies into a seperate addMessage call for delay processing
                  if (
                    index + 1 === array.length - 1 &&
                    array[array.length - 1].type === "quickReplies" // ContentType = "quick reply"
                  ) {
                    // is the last message in the list a quickrepl
                    addMessageObjList.push(addMessageObj, {
                      ...addMessageObj,
                      id: addMessageObj.id + "qr",
                      messageText: array[index + 1],
                    }); //add the last two message together with the same id
                  } else if (
                    array.length === 1 ||
                    array[index].type !== "quickReplies"
                  ) {
                    addMessageObjList.push(addMessageObj); // ContentType = regular text message
                  }
                });
            }

            break;

          default:
            logger.warn(
              "Unexpected message.data.ParticipantRole found! ",
              message
            );
            break;
        }
        break;

      default:
        logger.warn("Unexpected message.data.Type! ", message);
        break;
    }
    notifyParent("chatActive");
    return addMessageObjList;
  };

const handleTransferEvent = (contactId) => async (dispatch) => {
  try {
    await chatTransfer(config, contactId);
    dispatch({ type: SET_CHAT_CURRENT_CONTACT_ID, payload: contactId });
  } catch (error) {
    dispatch(
      setError({
        error: error,
        retryAction: () => dispatch(handleTransferEvent(contactId)),
        errorCode: "E006",
      })
    );
  }
};

//TODO - move to ChatUtil
const notifyParent = (message) => {
  const newMessage = {
    message: message,
    ChatId: config.ChatId,
  };
  // eslint-disable-next-line no-restricted-globals
  if (parent) parent.postMessage(newMessage, "*");
};
